<app-header></app-header>
<div class=" nav-md" [ngClass]="{'nav-md': shouldShow, 'nav-sm': !shouldShow}">
  <div class="container body"> <!--style="overflow:scroll"-->
    <div class="main_container">
      <div class="col-md-3 left_col">
        <app-sidebar></app-sidebar>
      </div>
      <div class="top_nav">
        <div class="nav_menu">
          <div class="nav toggle">
            <a id="menu_toggle" (click)="shouldShow = !shouldShow">
              <i class="las la-bars">
              </i></a>

              <!-- [ngClass]="{'la-times': shouldShow, 'la-bars': !shouldShow}" -->
          </div>
          <app-top-header></app-top-header>
        </div>
      </div>
      <div class="right_col" role="main">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <!--app-footer></app-footer-->
</div>